import { getStore } from '../../../init-store';
import { getConferenceConfig } from '../../pages/call/selectors';
import { ConferenceConfig } from '../../pages/call/types';
import { LAST_CONFERENCE_CONFIG_KEY } from '../features/settings/constants';
import WebStorage from './storage';

export const isConferenceConfig = (value: unknown): value is ConferenceConfig => {
    if (typeof value === 'object' && value) {
        if ('room_id' in value && 'resolved_uri' in value && 'peer_id' in value && 'media_platform' in value) {
            return true;
        }
    }
    return false;
};

export const getLastConferenceConfig = async (): Promise<ConferenceConfig | null> => {
    const state = getStore().getState();
    const storeConferenceConfig = getConferenceConfig(state);
    if (!storeConferenceConfig) {
        const rawValue = await WebStorage.getItem(LAST_CONFERENCE_CONFIG_KEY);
        const storageConferenceConfig = JSON.parse(rawValue ?? '{}');
        if (isConferenceConfig(storageConferenceConfig)) {
            return storageConferenceConfig;
        }
        return null;
    }
    return storeConferenceConfig;
};
